const isMac = typeof navigator !== "undefined" && /mac/i.test(navigator.platform);

const MODIFIER_DISPLAY: Record<string, string> = {
  mod: isMac ? "⌘" : "Ctrl+",
  meta: "⌘",
  ctrl: "Ctrl+",
  shift: "⇧",
  alt: isMac ? "⌥" : "Alt+",
};

const KEY_DISPLAY: Record<string, string> = {
  slash: "/",
  comma: ",",
  enter: "↵",
  escape: "Esc",
  backspace: "⌫",
  tab: "⇥",
  space: "Space",
};

/**
 * Compact shortcut label for inline badges, e.g. "⌘," or "⇧/" or "⌘⇧N".
 * Takes the first variant from a comma-separated hotkey string.
 */
export function formatHotkeyCompact(keys: string): string {
  const firstVariant = keys.split(",")[0].trim();
  return firstVariant
    .split("+")
    .map((k) => {
      if (k in MODIFIER_DISPLAY) return MODIFIER_DISPLAY[k];
      if (k in KEY_DISPLAY) return KEY_DISPLAY[k];
      return k.toUpperCase();
    })
    .join("");
}
